/* eslint-disable no-shadow */
import React from 'react';
import { Form, RadioGroup } from 'react-form';
import PropTypes from 'prop-types';
import Modal from '../../components/Modal/ReactBootstrapModal';
import {
    CheckBox,
    RadioButton,
} from '../../components/Form';

const PrintMatchSheetModal = (props) => {
    const { onCloseClick, onConfirmPrint, showMarkPrinted } = props;

    const defaultValues = {
        scoreSheetType: 'official',
        pageFormat: 'halfSheet',
        markPrinted: true,
    };

    return (
        <Modal visible={true} onClickBackdrop={onCloseClick}>
            <div className="modal-header">
                <div className="text-medium">Print score sheet</div>
                <div className="close-icon" onClick={onCloseClick}><i className="utr utr-close" /></div>
            </div>
            <div className="modal-body">
                <Form onSubmit={onConfirmPrint} defaultValues={defaultValues}>
                    {({ submitForm }) => {
                        return (
                            <form onSubmit={submitForm}>
                                <div className="form-wrapper">
                                    <label>Please select the score sheet type you&apos;d like to print:</label>
                                    <RadioGroup field="scoreSheetType">
                                        <RadioButton
                                            label="Official"
                                            value="official"
                                            id="official"
                                        />
                                        <RadioButton
                                            label="Simple"
                                            value="simple"
                                            id="simple"
                                        />
                                    </RadioGroup>
                                </div>
                                <div className="form-wrapper">
                                    <label>Please select the page format you’d like to print:</label>
                                    <RadioGroup field="pageFormat">
                                        <RadioButton
                                            label="Half-sheet"
                                            value="halfSheet"
                                            id="halfSheet"
                                            checked="checked"
                                        />
                                        <RadioButton
                                            label="Full-sheet"
                                            value="fullSheet"
                                            id="fullSheet"
                                        />
                                    </RadioGroup>
                                </div>
                                {showMarkPrinted && (
                                    <div className="form-wrapper">
                                        <CheckBox
                                            id="markPrinted"
                                            field="markPrinted"
                                            customLabel={<span className={'text-medium text-weight-normal'}>Mark match as printed.</span>}
                                            formGroupCssClass="mt16 mb8"
                                        />
                                    </div>
                                )}
                                <div className="row">
                                    <div className="col-md-6">
                                        <button type="button" className={`btn btn-xl btn-block btn-default`} onClick={onCloseClick}>Cancel</button>
                                    </div>
                                    <div className="col-md-6">
                                        <button type="submit" className="btn btn-xl btn-block btn-primary">Print</button>
                                    </div>
                                </div>
                            </form>
                        );
                    }}
                </Form>
            </div>
        </Modal>
    );
};

PrintMatchSheetModal.propTypes = {
    onCloseClick: PropTypes.func.isRequired,
    onConfirmPrint: PropTypes.func.isRequired,
    showMarkPrinted: PropTypes.bool,
};
PrintMatchSheetModal.defaultProps = {
    showMarkPrinted: false,
};

export default PrintMatchSheetModal;
